export interface WaitlistServiceItem {
    serviceId: string
    userId?: string
    parentServicesOnInvoicesId?: string
}

export interface WaitlistMatch {
    scheduleId: string
    start: Date
    end: Date
    serviceId: string
    userId?: string
}

export class WaitlistEntryEntity {
    waitlistEntryId: string
    companyId: string
    personId: string
    services: WaitlistServiceItem[]
    dateStart?: Date
    dateEnd?: Date
    timeStartMinute?: number
    timeEndMinute?: number
    weekdays: number[]
    durationMinutes: number
    notes?: string
    timezone: number
    matches?: WaitlistMatch[]
    status: number
    createdAt: Date
    updatedAt: Date
}
